import React, { memo, Children } from 'react';
import type { NamedExoticComponent } from 'react';
import { wrapWithComponent, isElementOfType } from './utils';

import { Group } from './Group';
import { Item } from './Item';
import styles from './styles.module.sass';

export interface FormLayoutProps {
    /** The content to display inside the layout. */
    children?: any;
}

export const FormLayout = memo(function FormLayout({ children }: FormLayoutProps) {
    return <div className={styles.FormLayout}>{Children.map(children, wrapChildren)}</div>;
}) as NamedExoticComponent<FormLayoutProps> & {
    Group: typeof Group;
};

FormLayout.Group = Group;

function wrapChildren(child: React.ReactElement, index: number) {
    if (isElementOfType(child, Group)) {
        return child;
    }
    const props = {};
    return wrapWithComponent(child, Item, props, index);
}
